<template>
  <div class="z-pb-1200">
    <YContainer>
      <z-breadcrumb
        :items="[
          { text: 'Home', url: 'https://querobolsa.com.br/' },
          { text: 'Manual do Enem' },
        ]"
      />

      <MontillaSlot slug="enem-home-banner" />

      <z-title
        tag="h1"
      >
        Manual do Enem
      </z-title>

      <z-text tag="p">
        Bem-vindo(a) ao fim dos surtos pré-Enem!
      </z-text>

      <z-text tag="p">
        Aqui, no Manual do Enem, você irá encontrar todos os conteúdos relacionados ao Exame Nacional do Ensino Médio e a diversos vestibulares e provas. Sem neuras, é só se jogar.
      </z-text>

      <z-text tag="p">
        Bons estudos! <span
          role="img"
          aria-label="Emoji com um leve sorriso"
        >🙂</span>
      </z-text>

      <div class="categories">
        <z-card
          v-for="category in categories"
          :key="category.slug"
          :style="{ borderColor: category.color }"
          shadow="high"
          class="categories__card js-category-card"
          :data-color="category.color"
          @mouseenter.native="onMouseEnter"
          @mouseleave.native="onMouseLeave"
        >
          <z-link
            :href="`/enem/${category.slug}`"
            class="categories__link"
          >
            <div class="categories__icon-wrapper js-category-card-icon">
              <z-icon
                :icon="['fal', categorySlugIconMap[category.slug]]"
                size="extra-jumbo"
                class="categories__icon"
              />
            </div>

            <z-title size="nano">
              {{ category.name }}
            </z-title>
          </z-link>
        </z-card>
      </div>
    </YContainer>
  </div>
</template>

<script>
import { YContainer } from '@quero/yeti'

import { CATEGORY_ICON_MAP } from '~/assets/js/services/categories'
import { getCategories } from '~/assets/js/services/graphqlApi'
import { retry } from '~/assets/js/utils/http'
import MontillaSlot from '~/components/montilla-slot'

export default {
  name: 'ManualDoEnemIndex',
  components: {
    YContainer,
    MontillaSlot,
  },
  async asyncData ({ $cms, error }) {
    try {
      const query = getCategories()
      const graphqlQuery = {
        query,
      }
      const categories = (await retry(
        () => $cms.$post('/graphql', graphqlQuery),
        { retries: 6 },
      ).then((response) => {
        return response.data.ManualDoEnemCategorias
      }))

      return {
        categories,
      }
    } catch (err) {
      error({ statusCode: 500, message: 'Failed to fetch categories' })
    }
  },
  data () {
    return {
      categories: [],
      categorySlugIconMap: CATEGORY_ICON_MAP,
    }
  },
  head () {
    return {
      title: 'Manual do Enem - Quero Bolsa',
      meta: [
        { hid: 'description', name: 'description', content: 'Aqui no Manual do Enem, você encontra conteúdos, videos e exercícios relacionados ao Enem e Vestibulares. Aprenda Matemática, Redação, Biologia, Português, etc.' },
      ],
      script: [{
        src: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_CHTML',
        async: true,
        defer: true,
      }],
    }
  },
  mounted () {
    window.montilla.track('category_view', { content_view_name: 'manual-do-enem' })
  },
  methods: {
    onMouseEnter ({ target: card }) {
      card.querySelector('.js-category-card-icon').style.backgroundColor = card.dataset.color
    },
    onMouseLeave ({ target: card }) {
      card.querySelector('.js-category-card-icon').style.removeProperty('background-color')
    },
  },
}
</script>

<style lang="scss">
.categories {
  display: grid;
  gap: var(--unit-0600);
  margin-top: var(--unit-1200);

  @media (min-width: $breakpoint-tablet) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.categories__card {
  border-top-width: var(--border-width-large);
  border-top-style: solid;
  min-height: 200px;
  padding: 0;
}

.categories__link {
  --color-interactive-hover: var(--color-gray-700);
  --color-interactive-normal: var(--color-gray-500);

  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: var(--unit-0600);

  &:hover {
    & .categories__icon {
      color: var(--color-white);
    }
  }
}

.categories__icon-wrapper {
  align-items: center;
  background: var(--color-gray-000);
  border-radius: var(--border-radius-circle);
  display: flex;
  height: var(--unit-1700);
  justify-content: center;
  margin-bottom: var(--unit-0400);
  margin-left: auto;
  margin-right: auto;
  width: var(--unit-1700);
}
</style>
